import Axios from 'axios';
import Diff from 'diff-match-patch'

export function runQuery(query: string, sparqlEndpoint: string = "https://sparql.scta.info/ds/query", requestType: string = "get"){
  if (requestType == "post"){
    const queryPromise = Axios.get(sparqlEndpoint, { params: { "query": query, "output": "json" } })
    return queryPromise
  }
  else{
    const queryPromise = Axios.get(sparqlEndpoint, { params: { "query": query, "output": "json" } })
    return queryPromise
  }
  
}

export function textReduce(text: string, wordRange: string) {
  const wordTokenStart = parseInt(wordRange.split("-")[0])
  const wordTokenEnd = parseInt(wordRange.split("-")[1])
  const wordTokens = text.split(" ")
  // NOTE: I'm not sure what this .filter(Boolean) is doing??
  const wordTokensClean = wordTokens.filter(Boolean)
  //const wordTokensBefore = wordTokensClean.slice(0, wordTokenStart - 1);
  //const wordTokensAfter = wordTokensClean.slice(wordTokenEnd)
  const wordTokensFocus = wordTokensClean.slice(wordTokenStart - 1, wordTokenEnd)
  const reducedText = wordTokensFocus.join(" ")
  return reducedText
  // let textElement = ""
  //     if (context){
  //       textElement = "<p class='text'><span>" + wordTokensBefore.join(" ") + "</span> <span style='font-weight: bold'>" + wordTokensFocus.join(" ") + "</span> <span>" + wordTokensAfter.join(" ") +"</span></p>"
  //     }
  //     else{
  //       textElement = "<p class='text'>" + wordTokensFocus.join(" ") + "</p>"
  //     }
  //   return textElement
}

export function getLineNumber(url: string, selectedText: string, selectedElementTargetId: string) {
  //https://github.com/scta-texts/plaoulcommentary/edit/master/lectio1/lectio1.xml#L117
  //https://raw.githubusercontent.com/scta-texts/plaoulcommentary/master/lectio1/lectio1.xml
  //https://raw.githubusercontent.com/scta-texts/plaoulcommentarymaster/lectio1/lectio1.xml
  const newRawUrl = url.replace("https://github.com", "https://raw.githubusercontent.com").replace("/raw/", '/')
  const file = Axios.get(newRawUrl)
  const data = file.then((d) => {
    const findElement = "xml:id=\"" + selectedElementTargetId + "\""
    const splitText = d.data.split(findElement);
    const beforeText = splitText[0]
    const splitBeforeText = beforeText.split('\n');
    const newLineCount = splitBeforeText.length

    const afterText = splitText[1]
    const regexp = new RegExp(`\\W${selectedText}\\W`, 'gi')
    const elementBeforeText = afterText.split(regexp)[0] // this is flawed, first instance of the same text will be used
    const splitElementBeforeText = elementBeforeText.split('\n');
    const newElementLineCount = splitElementBeforeText.length
    return newLineCount + newElementLineCount - 1
  })
  return data
}

export function goToGitHubEdit(url: string, selectedText: string, selectedElementTargetId: string) {
    if (!url.includes("github")){  
      const docSourceQuery: string = `SELECT ?doc WHERE {<${url}> <http://scta.info/property/hasDocument> ?doc .}`
      runQuery(docSourceQuery).then((d) => {
        const newUrl = d.data.results.bindings[0].doc?.value.split("#")[0]
        console.log("test", newUrl, selectedText, selectedElementTargetId)
        const data = getLineNumber(newUrl, selectedText, selectedElementTargetId)
        //https://github.com/scta-texts/plaoulcommentary/raw/master/lectio1/lectio1.xml
        data.then((d) => {
          const editUrl = newUrl.replace("raw", "edit") + "#L" + d
          window.open(editUrl, "gitHubEditWindow", 'height=750,width=750');
          //window.open(editUrl, "_blank"); 
        })
      })
    }
    else{
    console.log("test", url, selectedText, selectedElementTargetId)
    const data = getLineNumber(url, selectedText, selectedElementTargetId)
    //https://github.com/scta-texts/plaoulcommentary/raw/master/lectio1/lectio1.xml
    data.then((d) => {
      const editUrl = url.replace("raw", "edit") + "#L" + d
      window.open(editUrl, "gitHubEditWindow", 'height=750,width=750');
      //window.open(editUrl, "_blank"); 
    })
  }
}

export const getlevenshteinDistance = (base: string, compare: string) => {
  // const dmp = new diff_match_patch();
  
  const dmp = new Diff.diff_match_patch();
  const diff = dmp.diff_main(base, compare); //character level diff
  // Result: [(-1, "Hell"), (1, "G"), (0, "o"), (1, "odbye"), (0, " World.")]
  dmp.diff_cleanupSemantic(diff);
  const levenshteinDistance = dmp.diff_levenshtein(diff)
  return levenshteinDistance
}




// see for function inspiration: https://stackoverflow.com/questions/54580032/sigmoid-with-large-number-in-javascript#54580145
export function sigmoid(z: number) {
if (z === -1){
  return z
}
else{
  const k = 500
  const sigmoid = (1 / (1 + Math.exp(-z/k)));
  //return sigmoid - 0.5*(1.25-sigmoid)
  return sigmoid - (1 - sigmoid)
}
}

export const smoothScrollTo = (target: any, duration:number) => {
  const container = document.getElementsByClassName('textWrapper')[0];// this could be passed as an argument
  //const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 100;
  const targetPosition = target.getBoundingClientRect().top + container.scrollTop - 100;
  //const startPosition = window.pageYOffset;
  
    const startPosition = container.scrollTop;
  const distance = targetPosition - startPosition;
  let startTime = null;

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, distance, duration);
    
    container.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  const ease = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  requestAnimationFrame(animation);
};


export const copyToClipboard = (text: string) => {
  var dummy = document.createElement("textarea");
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}